module.exports = __webpack_public_path__ + "static/fabric-datepicker-format-e8d012a8e8913ee60f57d2402ae3b6b6.png";